import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2025"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M10.611 11.4H9.389a.06.06 0 0 1-.051-.093L10.5 9.511a.13.13 0 0 0-.109-.2h-2.09a.254.254 0 0 0-.223.131l-1.553 2.799a.186.186 0 0 0 .162.276h1.249a.06.06 0 0 1 .058.077l-.86 2.956 3.612-3.838a.185.185 0 0 0-.135-.312zm.673 1.634c0 .921.746 1.666 1.669 1.666s1.669-.745 1.669-1.666-1.669-3.333-1.669-3.333-1.669 2.411-1.669 3.333z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.265 4.449H1.735a1 1 0 1 1 0-2h12.529a1 1 0 1 1 .001 2zm0 3.965H1.735a1 1 0 1 1 0-2h12.529a1 1 0 1 1 .001 2zM5.03 12.426H1.735a1 1 0 1 1 0-2H5.03a1 1 0 1 1 0 2z",
  style: {"fill":"#060001"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }